import { listPatients } from './index';

import { patientsRouteStore } from '../domain/store';

export default (e) => {
  patientsRouteStore.setValue('filterValue', e.target.value);
  patientsRouteStore.setValue('currentPage', 1);
  return listPatients();
};
